import WalletModule from './views/Module.vue';
import Wallet from './views/Wallet.vue';
import WalletDeposit from './views/WalletDeposit.vue';
import WalletHistory from './components/WalletHistory.vue';
import WalletHistoryDetail from './views/WalletHistoryDetail.vue';
import PaymentMethod from './views/PaymentMethod.vue';
import DepositPaymentMethod from './views/DepositPaymentMethod.vue';
import WalletWithdraw from './views/WalletWithdrawal.vue';
import Transactions from '../wallet/views/Transactions.vue';

const WalletRoutes = {
    path: '/',
    component: WalletModule,
    children: [
      {
        path: 'wallet',
        name: 'wallet',
        component: Wallet,
      },
      {
        path: 'wallet-deposit',
        name: 'wallet-deposit',
        component: WalletDeposit,
      },
      {
        path: 'wallet-history',
        name: 'wallet-history',
        component: WalletHistory,
      },
      {
        path: 'wallet-history-detail/:type',
        name: 'wallet-history-detail',
        component: WalletHistoryDetail,
      },
      {
        path: 'payment-method',
        name: 'payment-method',
        component: PaymentMethod,
      },
      {
        path: 'deposit-payment-method',
        name: 'deposit-payment-method',
        component: DepositPaymentMethod,
      },
      {
        path: 'wallet-withdraw',
        name: 'wallet-withdraw',
        component: WalletWithdraw,
      },
      {
        path: 'transactions',
        name: 'transactions',
        component: Transactions 
      }
    ],
}

export default WalletRoutes;